import { apiClient } from "@nimbus-erp/api-client";
import type { SessionUser } from "@nimbus-erp/shared";
import { create } from "zustand";

interface AuthState {
  user: SessionUser | null;
  initialized: boolean;
  setUser: (user: SessionUser | null) => void;
  setInitialized: (initialized: boolean) => void;
  reset: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  initialized: false,
  setUser: (user) => { apiClient.setExpectedTenant(user?.tenantId ?? null); set({ user }); },
  setInitialized: (initialized) => set({ initialized }),
  reset: () => { apiClient.setExpectedTenant(null); set({ user: null, initialized: true }); },
}));
